import { useEffect, useState } from 'react';
import axios from 'axios';

export default function ServiceTubes(props) {

  let Euro = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });

  let tubeRows = props.machine.tubes==undefined || props.machine.tubes.length==0 ? 
    <tr>
      <td>---</td>
      <td>---</td>
      <td>---</td>
      <td>---</td>
      <td>---</td>
    </tr>
  : props.machine.tubes.map(tube => <tr>
      <td>{tube.tube}</td>
      <td>{Euro.format(tube.coin*0.01)}</td>
      <td>{tube.actual_amount}</td>
      <td>{tube.desired_amount}</td>
      <td>{tube.max_amount}</td>
    </tr>);

  return (
    <div>
      <table className="ui unstackable table">
        <thead>
          <tr>
            <th>Tube</th>
            <th>Münze</th>
            <th>Ist</th>
            <th>Soll</th>
            <th>Max</th>
          </tr></thead>
        <tbody>
          {tubeRows}
        </tbody>
      </table>
    </div>
  );
}